import { parseISO as a, intlFormatDistance as i } from "date-fns";
function u(e) {
  return e > 9 ? "9+" : e;
}
function l(e, t = {}) {
  try {
    const r = a(e);
    return i(r, /* @__PURE__ */ new Date(), {
      locale: t.locale
    });
  } catch {
    return e;
  }
}
function d(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function f(e, t) {
  return e !== void 0 ? e : t;
}
function m(e, t, r = {}) {
  return [e, t, r.source, r.tenant, r.has_tenant, r.archived].filter((n) => n != null).join("-");
}
function s({
  knockSlackChannelId: e,
  tenantId: t,
  connectionStatus: r,
  errorLabel: n
}) {
  return [e, t, r, n].filter((o) => o != null).join("-");
}
function v({
  knockMsTeamsChannelId: e,
  tenantId: t,
  connectionStatus: r,
  errorLabel: n
}) {
  return [e, t, r, n].filter((o) => o != null).join("-");
}
export {
  m as feedProviderKey,
  u as formatBadgeCount,
  l as formatTimestamp,
  v as msTeamsProviderKey,
  f as renderNodeOrFallback,
  s as slackProviderKey,
  d as toSentenceCase
};
//# sourceMappingURL=utils.mjs.map
